import { HeroCarousel } from "@/components/home/HeroCarousel";
import { Button, Highlight, Section } from "@/components/ui";
import { useCountUp } from "@/lib/useCountUp";
import { HERO, HERO_STATS } from "@/data/home";

function StatNumber({ stat }) {
  const animated = useCountUp(stat.to ?? 0);
  if (stat.static) return <b className="block font-heading text-4xl font-bold leading-none sm:text-5xl">{stat.static}</b>;
  return (
    <b className="block font-heading text-4xl font-bold leading-none sm:text-5xl">
      <span className="sr-only">
        {stat.to}
        {stat.suffix ?? ""}
      </span>
      <span aria-hidden="true">
        {animated}
        {stat.suffix ?? ""}
      </span>
    </b>
  );
}

export function HomeHero() {
  return (
    <Section tone="brandTint" testId="home-hero" labelledBy="home-hero-title" spacing="hero">
      <div className="relative z-10">
        <div className="grid items-center gap-8 lg:grid-cols-12 lg:gap-10">
          <div className="lg:col-span-7">
            <h1
              id="home-hero-title"
              className="font-heading text-4xl font-bold leading-[1.08] sm:max-w-[22ch] sm:text-5xl lg:text-5xl xl:text-6xl"
            >
              {HERO.h1Lead}{" "}
              <Highlight>{HERO.h1Accent}</Highlight>
            </h1>
            <p className="mt-4 text-base text-ink/80 sm:mt-5 sm:whitespace-nowrap sm:text-lg">{HERO.sub}</p>
            <div className="mt-7">
              <Button href={HERO.cta.to} size="lg" data-testid="home-hero-cta">
                {HERO.cta.label}
              </Button>
            </div>
          </div>

          <div className="lg:col-span-5">
            <HeroCarousel slides={HERO.slides} />
          </div>
        </div>

        <ul className="mt-8 grid grid-cols-2 lg:mt-10 gap-3 sm:grid-cols-4" data-testid="home-stats">
          {HERO_STATS.map((stat) => (
            <li key={stat.id} className="rounded-3xl border border-brand-200 bg-white p-4 sm:p-5">
              <StatNumber stat={stat} />
              <span className="mt-1 block text-sm text-ink/70 sm:text-base">{stat.label}</span>
            </li>
          ))}
        </ul>
      </div>
    </Section>
  );
}




